import React, { useState, useEffect } from "react";
import "./index.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LcIconLink from "../../../components/Generic/LcIconLink";
import LcIcon from "../../../components/Generic/LcIcon";

interface Props {
    open: boolean,
    list: any[],
    optionColumns: any,
    handleClickItem: Function,
    handleChangeColumns: Function,
    handleCloseModal: Function,
}

const AttendanceDragNDropComponent: React.FC<Props> = (props) => {
    const [itemList, setItemList] = useState<any[]>([]);
    const [selectedRow, setSelectedRow] = useState<any>();
    const [selectedIndex, setSelectedIndex] = useState<number>(0);
    const [visibleSelected, setVisibleSelected] = useState<any>();

    useEffect(() => {
        if (props.open) {
            const itemsShow = props.list.filter((x: any) => x.hide !== true);
            const itemsNotShow = props.list.filter((x: any) => x.hide === true);

            const updatedList = [...itemsShow, ...itemsNotShow];

            setItemList(updatedList);
            props.handleChangeColumns(updatedList);

            setSelectedRow([]);
            setSelectedIndex(-1);
        }
    }, [props.open])

    const handleDrop = (droppedItem: any) => {
        if (!droppedItem.destination) {
            return;
        }

        var updatedList = [...props.list];
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);

        setItemList(updatedList);

        setSelectedRow(reorderedItem);
        setSelectedIndex(droppedItem.destination.index);
        props.handleChangeColumns(updatedList);
    };

    const handleClick = (item: any, index: number) => {
        setSelectedIndex(index);
        setSelectedRow(item);
    }

    const handleUpArrow = () => {
        if (selectedRow.length !== 0) {
            const nextIndex = (selectedIndex - 1 > 0) ? selectedIndex - 1 : 0;

            var updatedList = [...props.list];
            const [reorderedItem] = updatedList.splice(selectedIndex, 1);
            updatedList.splice(nextIndex, 0, reorderedItem);

            setItemList(updatedList);
            setSelectedIndex(nextIndex);
            props.handleChangeColumns(updatedList);
        }
    }

    const handleDownArrow = () => {
        if (selectedRow.length != 0) {
            const nextIndex = (selectedIndex + 1 < props.list.length - 1) ? selectedIndex + 1 : props.list.length - 1;

            var updatedList = [...props.list];
            const [reorderedItem] = updatedList.splice(selectedIndex, 1);
            updatedList.splice(nextIndex, 0, reorderedItem);

            setItemList(updatedList);
            setSelectedIndex(nextIndex);
            props.handleChangeColumns(updatedList);
        }
    }

    const handleClickItem = (item) => {
        const updatedList = itemList.map((x: any) => {
            if (x.field === item.field) {
                x.hide = !x.hide;
            }

            return x;
        });

        props.handleClickItem(item, updatedList);
    }

    // const handleChangeColumns = () => {
    //     props.handleChangeColumns(itemList);
    //     props.handleCloseModal();
    // }

    return (
        <div className={"AppDrag"}>
            <DragDropContext onDragEnd={handleDrop}>
                <Droppable className={"divSizeTesteDragDrop"} droppableId={"list-container"}>
                    {
                        (provided: any) => (
                            <div
                                className={"list-container"}
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                {
                                    itemList.map((item, index) => (
                                        <Draggable key={item.field} draggableId={item.field} index={index}>
                                            {
                                                (provided: any) => (
                                                    <div
                                                        className={"item-container"}
                                                        ref={provided.innerRef}
                                                        onClick={() => handleClick(item, index)}
                                                        onMouseOver={() => setVisibleSelected(item.field)}
                                                        onMouseLeave={() => setVisibleSelected("")}
                                                        {...provided.dragHandleProps}
                                                        {...provided.draggableProps}
                                                    >
                                                        <div
                                                            className={"item-container2"}
                                                            // onClick={() => handleClickItem(item)}
                                                            style={{
                                                                backgroundColor: (item === selectedRow) ? "rgb(238, 238, 238)" : "",
                                                                width: (item === selectedRow) ? "auto" : "",
                                                                marginLeft: '0px',
                                                                borderRadius: "8px"
                                                            }}
                                                        >
                                                            {
                                                                visibleSelected && item.field === visibleSelected &&
                                                                <div className={"divOrderSortIconDragNDrop"}>
                                                                    <LcIcon icon={"ppi ppi-drag-vertical"} />
                                                                </div>
                                                            }
                                                            {/* {
                                                                props.optionColumns[item.field] === true
                                                                    ? <div className={"divOrderIconCheckDragNDrop"}>
                                                                        <LcIcon icon={"ppi ppi-checkbox-on"} color={'#ffb800'} />
                                                                    </div>
                                                                    : <div className={"divOrderIconCheckDragNDrop"}>
                                                                        <LcIcon icon={"ppi ppi-checkbox"} color={'#cccccf'} />
                                                                    </div>
                                                            } */}

                                                            <div className={"divOrderIconCheckDragNDrop"}>
                                                                {
                                                                    (props.optionColumns[item.field] === true)
                                                                        ? <LcIconLink icon={"ppi ppi-checkbox-on"} color={'#ffb800'} onClick={() => handleClickItem(item)} />
                                                                        : <LcIconLink icon={"ppi ppi-checkbox"} color={'#cccccf'} onClick={() => handleClickItem(item)} />
                                                                }
                                                            </div>

                                                            <span style={{ position: "absolute", left: "85px" }}>{item.headerName}</span>

                                                            {/* <div className={"divOrderIconDragNDrop"}>
                                                                <LcIconLink
                                                                    icon={(props.optionColumns[item.field] == true) ? "ppi ppi-minus" : "ppi ppi-plus"}
                                                                    tooltip={(props.optionColumns[item.field] == true) ? "Remover coluna" : "Adicionar Coluna"}
                                                                    size={'small'}
                                                                />
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </Draggable>
                                    ))
                                }
                                {provided.placeholder}
                            </div>
                        )
                    }
                </Droppable>
            </DragDropContext>

            <div className={"iconDivDragNDrop"} style={{ position: (props.open) ? "fixed" : "relative" }}>
                {
                    (selectedRow && selectedRow.length !== 0)
                        ? <LcIconLink icon={"ppi ppi-arrow-up"} onClick={() => handleUpArrow()} tooltip={""} tooltipPosition={"fullLeft"} />
                        : <LcIcon icon={"ppi ppi-arrow-up"} color={"grey"} tooltip={"Selecione uma coluna"} tooltipPosition={"fullLeft"} />
                }
                {
                    (selectedRow && selectedRow.length !== 0)
                        ? <LcIconLink icon={"ppi ppi-arrow-down"} onClick={() => handleDownArrow()} tooltip={""} tooltipPosition={"fullLeft"} />
                        : <LcIcon icon={"ppi ppi-arrow-down"} color={"grey"} tooltip={"Selecione uma coluna"} tooltipPosition={"fullLeft"} />
                }
                {/* <LcIconLink icon={"ppi ppi-check"} onClick={() => handleChangeColumns()} tooltip={"Aplicar mudanças"} tooltipPosition={"fullLeft"} />/ */}
            </div>
        </div>
    );
};

export default AttendanceDragNDropComponent;